export default __webpack_public_path__ + "static/media/hreo-image-master.31ed01eb.png";